<template>
  <div class="bill-page">
    <!-- 状态视图 Tab（对齐老系统 8 视图） -->
    <el-card class="filter-card" shadow="never">
      <el-tabs v-model="status" class="bill-tabs" @tab-click="reload">
        <el-tab-pane v-for="t in statusTabs" :key="String(t.value)" :label="t.label" :name="String(t.value)" />
      </el-tabs>

      <!-- 筛选栏 -->
      <div class="fg-row">
        <el-input
          v-model="keyword"
          class="fg-search"
          prefix-icon="el-icon-search"
          placeholder="搜索账单号 / 第三方单号 / 客户姓名 / 手机号"
          clearable
          @keyup.enter.native="reload"
          @clear="reload"
        />
        <el-button type="primary" icon="el-icon-search" @click="reload">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetFilters">重置</el-button>
      </div>
      <div class="fg-row">
        <div class="fg-item">
          <span class="fg-label">账单类型</span>
          <el-select v-model="billType" placeholder="全部类型" clearable style="width: 150px" @change="reload">
            <el-option label="普通收款" :value="1" />
            <el-option label="分期账单" :value="2" />
          </el-select>
        </div>
        <div class="fg-item">
          <span class="fg-label">创建时间</span>
          <el-date-picker
            v-model="range"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 280px"
            @change="reload"
          />
        </div>
        <div class="fg-item">
          <span class="fg-label">收款平台</span>
          <el-select v-model="paytypeId" placeholder="全部平台" clearable style="width: 150px" @change="reload">
            <el-option v-for="p in paytypes" :key="p.id" :label="p.name" :value="p.id" />
          </el-select>
        </div>
        <template v-if="isCompany">
          <div class="fg-item">
            <span class="fg-label">战队</span>
            <el-select v-model="filterUnitId" placeholder="全部战队" clearable style="width: 150px" @change="onUnitChange">
              <el-option v-for="u in saleUnits" :key="u.id" :label="u.name" :value="u.id" />
            </el-select>
          </div>
          <div class="fg-item">
            <span class="fg-label">小组</span>
            <el-select v-model="filterTeamId" placeholder="全部小组" clearable style="width: 150px" @change="onTeamChange">
              <el-option v-for="t in saleTeams" :key="t.id" :label="t.name" :value="t.id" />
            </el-select>
          </div>
          <div class="fg-item">
            <span class="fg-label">销售</span>
            <el-select v-model="staffId" placeholder="全部销售" clearable style="width: 150px" @change="reload">
              <el-option v-for="s in salesStaffs" :key="s.id" :label="s.name" :value="s.id" />
            </el-select>
          </div>
        </template>
      </div>
    </el-card>

    <!-- 列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        empty-text="暂无账单数据"
      >
        <el-table-column prop="bill_sn" label="账单号" min-width="165">
          <template slot-scope="{ row }">
            <span class="sn-text">{{ row.bill_sn }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户" min-width="140">
          <template slot-scope="{ row }">
            <div class="cell-name-main">
              <div class="cell-name-text">{{ row.customer_name || '—' }}</div>
              <div class="cell-name-sub">{{ row.customer_phone || '' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分期信息" min-width="170">
          <template slot-scope="{ row }">
            <template v-if="parseInt(row.type) === 2">
              <div class="inst-main">第 {{ row.period_no }} 期</div>
              <div class="inst-sub">{{ row.paytype_name || '—' }} · {{ row.status_text }}</div>
            </template>
            <span v-else class="inst-main plain">普通收款</span>
          </template>
        </el-table-column>
        <el-table-column prop="staff_name" label="销售" min-width="90">
          <template slot-scope="{ row }">
            <span>{{ row.staff_name || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收款金额" min-width="100" align="right">
          <template slot-scope="{ row }">
            <span class="amount-text">¥{{ row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="收款时间" min-width="100">
          <template slot-scope="{ row }">
            <span class="cell-time">{{ fmtDate(row.paytime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" min-width="100">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.status)" size="small">{{ row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="业绩" min-width="90" align="right">
          <template slot-scope="{ row }">
            <span class="perform-text">{{ parseFloat(row.perform_amount) > 0 ? '¥' + row.perform_amount : '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="goDetail(row)">详情</el-button>
            <el-button v-if="canAudit && parseInt(row.status) === 2" type="text" size="small" @click="openAudit(row)">审核</el-button>
            <el-button v-if="canAudit && parseInt(row.type) === 2 && [1, 2, 5].indexOf(parseInt(row.status)) > -1" type="text" size="small" @click="doRepay(row)">还款</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pager-row">
        <div class="pager-info-left" v-if="total > 0">
          <span class="info-tag">
            显示第 <span class="num">{{ (page - 1) * limit + 1 }}</span> -
            <span class="num">{{ Math.min(page * limit, total) }}</span> 条，
            共 <span class="num">{{ total }}</span> 条记录
          </span>
        </div>
        <el-pagination
          background
          :layout="'total, sizes, prev, pager, next, jumper'"
          :pager-count="7"
          :total="total"
          :current-page.sync="page"
          :page-size.sync="limit"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="onSizeChange"
          @current-change="loadData"
        />
      </div>
    </el-card>

    <!-- 账单详情弹框 -->
    <el-dialog
      title="账单详情"
      :visible.sync="detailVisible"
      width="640px"
      custom-class="bill-detail-dialog"
    >
      <div v-loading="detailLoading" class="detail-body">
        <template v-if="detail.id">
          <!-- 头部 -->
          <div class="detail-head">
            <div class="head-sn-row">
              <span class="head-sn">{{ detail.bill_sn }}</span>
              <el-tag :type="statusTagType(detail.status)" size="small" effect="dark">{{ detail.status_text }}</el-tag>
              <el-tag size="small" effect="plain" type="info">{{ detail.type_text }}</el-tag>
            </div>
            <div class="head-customer">
              <div class="head-avatar">{{ ((orderInfo.customer_name) || '客').substring(0, 1) }}</div>
              <div class="head-customer-info">
                <div class="head-customer-name">{{ orderInfo.customer_name || '未填写' }}</div>
                <div class="head-customer-sub">{{ orderInfo.customer_phone || '未留手机号' }} · {{ detail.paytype_name || '—' }}</div>
              </div>
              <div class="head-price">
                <div class="head-price-label">{{ orderInfo.product_name || '—' }}</div>
                <div class="head-price-num">¥{{ detail.amount }}</div>
              </div>
            </div>
          </div>

          <!-- 基本信息 -->
          <div class="info-card">
            <div class="info-row">
              <span class="info-label">归属销售</span>
              <span class="info-value">{{ detail.staff_name || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">收款平台</span>
              <span class="info-value">{{ detail.paytype_name || '—' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">收款时间</span>
              <span class="info-value">{{ fmtDateTime(detail.paytime) }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">创建时间</span>
              <span class="info-value">{{ fmtDateTime(detail.createtime) }}</span>
            </div>
            <div v-if="detail.transaction_id" class="info-row">
              <span class="info-label">第三方单号</span>
              <span class="info-value">{{ detail.transaction_id }}</span>
            </div>
            <div v-if="detail.audit_remark" class="info-row info-row-block">
              <span class="info-label">审核备注</span>
              <span class="info-value info-value-block">{{ detail.audit_remark }}</span>
            </div>
          </div>

          <!-- 业绩快照 -->
          <div class="section-card">
            <div class="section-title">业绩快照</div>
            <div class="info-card-inner">
              <div class="info-row">
                <span class="info-label">是否计入业绩</span>
                <span class="info-value">{{ detail.in_perform_text }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">核算比例</span>
                <span class="info-value">{{ parseFloat(detail.rate) > 0 ? (parseFloat(detail.rate) * 100) + '%' : '—' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">核算业绩</span>
                <span class="info-value perform-strong">¥{{ detail.perform_amount || '0.00' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">核算日期</span>
                <span class="info-value">{{ detail.perform_date || '—' }}</span>
              </div>
            </div>
          </div>

          <!-- 关联分期 -->
          <div v-if="installment" class="section-card">
            <div class="section-title">关联分期</div>
            <div class="info-card-inner">
              <div class="info-row">
                <span class="info-label">分期状态</span>
                <span class="info-value">{{ installment.status_text }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">分期总额</span>
                <span class="info-value">¥{{ installment.amount }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">期数</span>
                <span class="info-value">{{ installment.periods }} 期 · 每期 ¥{{ installment.per_amount }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">首次还款日</span>
                <span class="info-value">{{ installment.first_date || '—' }}</span>
              </div>
            </div>
          </div>

          <!-- 关联订单 -->
          <div v-if="orderInfo.id" class="section-card">
            <div class="section-title">关联订单</div>
            <div class="info-card-inner">
              <div class="info-row">
                <span class="info-label">订单号</span>
                <span class="info-value sn-text">{{ orderInfo.order_sn }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">客户</span>
                <span class="info-value">{{ orderInfo.customer_name }} {{ orderInfo.customer_phone || '' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">下单商品</span>
                <span class="info-value">{{ orderInfo.product_name || '—' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">商品价格</span>
                <span class="info-value">¥{{ orderInfo.price }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">订单录入时间</span>
                <span class="info-value">{{ fmtDateTime(orderInfo.createtime) }}</span>
              </div>
            </div>
          </div>

          <!-- 收款凭证 -->
          <div v-if="detail.voucher" class="section-card voucher-card">
            <div class="section-title">收款凭证</div>
            <el-image :src="detail.voucher" fit="contain" class="voucher-img" :preview-src-list="[detail.voucher]" />
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="canAudit && parseInt(detail.status) === 2" type="primary" size="small" @click="openAudit(detail)">审 核</el-button>
        <el-button size="small" @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 审核弹框 -->
    <el-dialog title="账单审核" :visible.sync="auditVisible" width="520px">
      <el-form ref="auditForm" :model="auditForm" :rules="auditRules" label-width="100px">
        <el-form-item label="账单号">
          <span class="audit-sn">{{ auditForm.bill_sn }}</span>
        </el-form-item>
        <el-form-item label="金额">
          <span class="audit-amount">¥{{ auditForm.amount }}</span>
        </el-form-item>
        <el-form-item label="审核结果" prop="action">
          <el-radio-group v-model="auditForm.action">
            <el-radio-button label="pass">通过</el-radio-button>
            <el-radio-button label="refuse">不通过</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="auditForm.action === 'pass'" label="核算日期" prop="perform_date">
          <el-date-picker
            v-model="auditForm.perform_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="默认收款/出账日期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="auditForm.action === 'refuse'" label="不通过原因" prop="audit_remark">
          <el-input v-model="auditForm.audit_remark" type="textarea" :rows="3" placeholder="请填写不通过原因" maxlength="255" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="auditVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="auditLoading" @click="submitAudit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { billList, billDetail, billAuditPass, billAuditRefuse, billRepay } from '@/api/bill'
import { paytypeList } from '@/api/base'
import { unitList, teamList, staffList } from '@/api/org'

const STATUS_TABS = [
  { label: '全部', value: 'all' },
  { label: '待审核', value: '2' },
  { label: '审核失败', value: '3' },
  { label: '已完成', value: '4' },
  { label: '未出账', value: '0' },
  { label: '已出账', value: '1' },
  { label: '已逾期', value: '5' },
  { label: '已还款', value: '6' }
]

export default {
  name: 'BillList',
  data() {
    return {
      status: 'all',
      statusTabs: STATUS_TABS,
      billType: null,
      keyword: '',
      range: null,
      paytypeId: null,
      paytypes: [],
      staffId: null,
      filterUnitId: null,
      filterTeamId: null,
      saleUnits: [],
      saleTeams: [],
      salesStaffs: [],
      list: [],
      page: 1,
      limit: 20,
      total: 0,
      loading: false,
      // 详情
      detailVisible: false,
      detailLoading: false,
      detail: {},
      orderInfo: {},
      installment: null,
      // 审核
      auditVisible: false,
      auditLoading: false,
      auditForm: {
        id: 0, bill_sn: '', amount: 0, action: 'pass', perform_date: '', audit_remark: ''
      },
      auditRules: {
        perform_date: [{ validator: (r, v, cb) => cb() }],
        audit_remark: [{ validator: (r, v, cb) => { if (this.auditForm.action === 'refuse' && !v) cb(new Error('请填写不通过原因')); else cb() } }]
      }
    }
  },
  computed: {
    ...mapState(['user']),
    isCompany() {
      return !!(this.user && this.user.type === 'company')
    },
    /* 审核/还款权限：机构管理员 或 队长（is_leader）；unit/team 也有审核权 */
    canAudit() {
      if (!this.user) return false
      if (this.user.type === 'company' || this.user.type === 'unit' || this.user.type === 'team') return true
      return this.user.type === 'staff' && parseInt(this.user.is_leader) === 1
    }
  },
  created() {
    this.loadPaytypes()
    if (this.isCompany) this.loadSalesStaffs()
    this.reload()
  },
  methods: {
    /* ===== 数据加载 ===== */
    reload() {
      this.page = 1
      this.loadData()
    },
    loadData() {
      if (this.loading) return
      this.loading = true
      const params = { page: this.page, limit: this.limit }
      if (this.status !== 'all') params.status = parseInt(this.status)
      if (this.billType) params.type = this.billType
      if (this.keyword) params.keyword = this.keyword
      if (this.paytypeId) params.paytype_id = this.paytypeId
      if (this.staffId) params.staff_id = this.staffId
      if (this.filterUnitId) params.unit_id = this.filterUnitId
      if (this.filterTeamId) params.team_id = this.filterTeamId
      if (this.range && this.range.length === 2) {
        params.start_date = this.range[0]
        params.end_date = this.range[1]
      }
      billList(params)
        .then(data => {
          this.list = data.list || []
          this.total = data.total || 0
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
        .finally(() => { this.loading = false })
    },
    loadPaytypes() {
      paytypeList()
        .then(d => { this.paytypes = d.list || [] })
        .catch(() => {})
    },
    loadSalesStaffs() {
      unitList()
        .then(du => {
          this.saleUnits = (du.list || []).filter(u => parseInt(u.type) === 2)
          return staffList({}).then(ds => ({ ds }))
        })
        .then(({ ds }) => {
          this.salesStaffs = (ds.list || []).filter(s => this.inSaleUnit(s) && parseInt(s.status) === 1)
        })
        .catch(() => {})
    },
    inSaleUnit(s) {
      return this.saleUnits.some(u => parseInt(u.id) === parseInt(s.unit_id))
    },
    onUnitChange() {
      this.filterTeamId = null
      this.staffId = null
      if (!this.filterUnitId) {
        this.saleTeams = []
        this.salesStaffs = []
        this.loadSalesStaffs()
        this.reload()
        return
      }
      teamList({ unit_id: this.filterUnitId })
        .then(dt => {
          this.saleTeams = dt.list || []
          return staffList({ unit_id: this.filterUnitId }).then(ds => ({ ds }))
        })
        .then(({ ds }) => { this.salesStaffs = (ds.list || []).filter(s => parseInt(s.status) === 1) })
        .catch(() => {})
        .finally(() => this.reload())
    },
    onTeamChange() {
      this.staffId = null
      if (!this.filterTeamId) {
        this.salesStaffs = []
        this.reload()
        return
      }
      staffList({ team_id: this.filterTeamId })
        .then(ds => { this.salesStaffs = (ds.list || []).filter(s => parseInt(s.status) === 1) })
        .catch(() => {})
        .finally(() => this.reload())
    },
    resetFilters() {
      this.keyword = ''
      this.billType = null
      this.range = null
      this.paytypeId = null
      this.staffId = null
      this.filterUnitId = null
      this.filterTeamId = null
      this.saleTeams = []
      if (this.isCompany) this.loadSalesStaffs()
      this.reload()
    },
    onSizeChange(size) {
      this.limit = size
      this.reload()
    },
    /* ===== 详情 ===== */
    goDetail(row) {
      this.detail = {}
      this.orderInfo = {}
      this.installment = null
      this.detailVisible = true
      this.detailLoading = true
      billDetail(row.id)
        .then(data => {
          this.detail = data.bill || {}
          this.orderInfo = data.order || {}
          this.installment = data.installment || null
        })
        .catch(() => { this.detailVisible = false })
        .finally(() => { this.detailLoading = false })
    },
    /* ===== 审核 ===== */
    openAudit(row) {
      this.auditForm = {
        id: row.id,
        bill_sn: row.bill_sn,
        amount: row.amount,
        action: 'pass',
        perform_date: '',
        audit_remark: ''
      }
      this.auditVisible = true
    },
    submitAudit() {
      if (this.auditForm.action === 'refuse' && !this.auditForm.audit_remark) {
        this.$message.warning('请填写不通过原因')
        return
      }
      this.auditLoading = true
      const done = () => {
        this.auditLoading = false
        this.auditVisible = false
        if (this.detailVisible) this.goDetail({ id: this.auditForm.id })
        this.loadData()
      }
      if (this.auditForm.action === 'pass') {
        billAuditPass(this.auditForm.id, this.auditForm.perform_date || '')
          .then(() => { this.$message.success('审核通过，业绩已固化'); done() })
          .catch(() => { this.auditLoading = false })
      } else {
        billAuditRefuse(this.auditForm.id, this.auditForm.audit_remark)
          .then(() => { this.$message.success('已驳回'); done() })
          .catch(() => { this.auditLoading = false })
      }
    },
    /* ===== 分期还款 ===== */
    doRepay(row) {
      this.$confirm(`确认标记「第 ${row.period_no} 期」账单为已还款？金额 ¥${row.amount}。`, '确认还款', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        billRepay(row.id)
          .then(() => {
            this.$message.success('已标记还款')
            this.reload()
          })
          .catch(() => {})
      }).catch(() => {})
    },
    /* ===== 工具 ===== */
    statusTagType(s) {
      const v = parseInt(s)
      if (v === 0) return 'info'
      if (v === 1) return 'info'
      if (v === 2) return 'warning'
      if (v === 3) return 'danger'
      if (v === 4) return 'success'
      if (v === 5) return 'danger'
      if (v === 6) return 'success'
      return 'info'
    },
    fmtDate(ts) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
    },
    fmtDateTime(ts) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    }
  }
}
</script>

<style scoped>
.bill-page { padding: 0; }

/* ===== 筛选卡 ===== */
.filter-card {
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.bill-tabs { margin-bottom: 4px; }

.fg-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin-bottom: 12px;
}

.fg-row:last-child { margin-bottom: 0; }

.fg-search { width: 280px; }

.fg-item { display: flex; align-items: center; gap: 8px; }

.fg-label { font-size: 13px; color: #8A94AD; flex-shrink: 0; }

/* ===== 表格卡 ===== */
.table-card {
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.sn-text {
  font-size: 12px;
  color: #5A6580;
  font-family: monospace;
  font-variant-numeric: tabular-nums;
}

.cell-name-main { min-width: 0; }

.cell-name-text {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #18233C;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-name-sub {
  display: block;
  font-size: 11px;
  color: #8A94AD;
  margin-top: 2px;
}

.inst-main { font-size: 13px; font-weight: 600; color: #18233C; }
.inst-main.plain { font-size: 12px; font-weight: 500; color: #5A6580; }
.inst-sub { font-size: 11px; color: #8A94AD; margin-top: 2px; }

.amount-text {
  font-size: 13px;
  font-weight: 600;
  color: #E8930C;
  font-variant-numeric: tabular-nums;
}

.perform-text {
  font-size: 13px;
  font-weight: 600;
  color: #3668FC;
  font-variant-numeric: tabular-nums;
}

.cell-time {
  font-size: 12px;
  color: #5A6580;
  font-variant-numeric: tabular-nums;
}

/* 分页器行 */
.pager-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 8px 8px;
  border-top: 1px solid #F2F4F8;
  margin-top: 4px;
}

.pager-info-left {
  font-size: 12px;
  color: #8A94AD;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-tag {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  background: #F4F6FB;
  border-radius: 6px;
  color: #5A6580;
  font-variant-numeric: tabular-nums;
}

.info-tag .num { color: #3668FC; font-weight: 600; margin: 0 2px; }

/* ===== 详情弹框 ===== */
.detail-body { min-height: 100px; }

.detail-head {
  background: linear-gradient(135deg, #3668FC 0%, #2952D8 60%, #5B8DFF 120%);
  border-radius: 12px;
  padding: 16px 20px;
  color: #FFF;
}

.head-sn-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.30);
}

.head-sn {
  font-size: 12px;
  font-family: monospace;
  opacity: 0.9;
}

.head-customer {
  display: flex;
  align-items: center;
  padding-top: 14px;
}

.head-avatar {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.20);
  border: 1px solid rgba(255, 255, 255, 0.40);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  flex-shrink: 0;
}

.head-customer-info { flex: 1; min-width: 0; margin-left: 12px; }

.head-customer-name {
  display: block;
  font-size: 16px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.head-customer-sub {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.85;
}

.head-price { text-align: right; flex-shrink: 0; }

.head-price-label {
  display: block;
  font-size: 12px;
  opacity: 0.85;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.head-price-num {
  display: block;
  margin-top: 4px;
  font-size: 22px;
  font-weight: 700;
}

/* 信息卡 */
.info-card {
  margin-top: 12px;
  border: 1px solid #E5E9F2;
  border-radius: 10px;
  padding: 0 16px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 11px 0;
  border-bottom: 1px solid #F2F4F8;
}

.info-row:last-child { border-bottom: none; }
.info-row-block { flex-direction: column; gap: 6px; }

.info-label { font-size: 12px; color: #8A94AD; flex-shrink: 0; }

.info-value {
  font-size: 13px;
  color: #2B3653;
  text-align: right;
  word-break: break-all;
  margin-left: 16px;
}

.info-value-block { text-align: left; margin-left: 0; line-height: 1.6; }
.perform-strong { color: #3668FC; font-weight: 700; }

/* 区块卡 */
.section-card {
  margin-top: 12px;
  border: 1px solid #E5E9F2;
  border-radius: 10px;
  padding: 12px 16px 0;
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #18233C;
  display: inline-flex;
  align-items: center;
  margin-bottom: 4px;
}

.section-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(180deg, #3668FC, #5B8DFF);
  margin-right: 8px;
}

.info-card-inner { padding: 0; }

.voucher-card { padding-bottom: 12px; }

.voucher-img {
  display: block;
  width: 100%;
  max-height: 260px;
  border-radius: 8px;
  margin-top: 8px;
}

/* 审核弹框 */
.audit-sn {
  font-size: 12px;
  color: #5A6580;
  font-family: monospace;
}

.audit-amount {
  font-size: 15px;
  font-weight: 700;
  color: #E8930C;
}

/* ===== Element UI 品牌色统一 ===== */
::v-deep .el-button--primary {
  background: #3668FC;
  border-color: #3668FC;
}

::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }

::v-deep .el-table__row:hover > td {
  background: #F5F8FF !important;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #3668FC;
  border-color: #3668FC;
}

::v-deep .el-tabs__item.is-active { color: #3668FC; }
::v-deep .el-tabs__active-bar { background-color: #3668FC; }
::v-deep .el-dialog { border-radius: 12px; }
</style>
